module.exports = "<button type=\"button\" class=\"btn btn-tessco-second\" (click)=\"download()\">Download</button>\n<a #downloadAnchor download style=\"display:none;\" target=\"_blank\"></a>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/file-download/file-download.component.html
// module id = ../../../../../src/app/file-download/file-download.component.html
// module chunks = main